import { Dispatch } from "components/Onboarding/Dispatch";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/")({
    component: Dispatch,
});
